import React from 'react';

import { Box, Typography } from '@mui/material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

import { useTheme } from 'hooks';

import type { Column } from 'api/shared/models';

import ColumnOptions from '../ColumnOptions';
import { styles } from '../styles';

interface Props {
  columns: Column[];
  showConfigName: boolean;
  onClick: (column: Column) => void;
  moveRows?: (rowIndex: number, newIndex: number) => void;
}

const MyColumns = ({ columns, showConfigName, onClick, moveRows }: Props) => {
  const { palette } = useTheme();

  return (
    <Box style={{ backgroundColor: palette.background.paper }}>
      <Typography variant="h6" sx={styles.headerColumn}>
        <DoneOutlinedIcon style={{ marginRight: 8 }} /> Mis columnas
      </Typography>
      <ColumnOptions
        columns={columns}
        onClick={onClick}
        showConfigName={showConfigName}
        addDragAndDrop
        moveRows={moveRows}
      />
    </Box>
  );
};

export default MyColumns;
